import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

const TOKEN_KEY = 'fz_access_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Always attach Bearer token if available (works even if cookies are blocked)
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear stale token so AuthContext can re-detect logged-out state
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && err?.config?.url !== '/auth/login') {
      setToken(null);
    }
    return Promise.reject(err);
  }
);

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${API}/files/${path}`;
}
